(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerRaceResumeDeleteController',RunnerRaceResumeDeleteController);

    RunnerRaceResumeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RunnerRaceResume'];

    function RunnerRaceResumeDeleteController($uibModalInstance, entity, RunnerRaceResume) {
        var vm = this;

        vm.runnerRaceResume = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RunnerRaceResume.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
